// Some auth endpoints report a rejected request in a successful HTTP response.
export function assertRecoverySuccess(data) {
  if (data?.error || data?.success === false || data?.ok === false) {
    const error = new Error('Password recovery request rejected');
    error.response = { data };
    throw error;
  }
  return data;
}

export function recoveryErrorKey(error) {
  if (error.response?.status === 429) return 'recovery.rate-limit';
  if (['ECONNABORTED', 'ETIMEDOUT'].includes(error.code)) return 'recovery.timeout';
  if (!error.response) return 'recovery.connection-error';
  return 'auth.reset-error';
}
